export default function Services() {
  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Transport Express',
      description: 'Livraison rapide et sécurisée de vos fleurs et plantes partout en France, avec respect des délais et de la fraîcheur des produits.'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Service Fleuristes',
      description: 'Solutions logistiques dédiées aux fleuristes professionnels, avec gestion optimale des commandes et livraisons régulières.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Grossistes & Professionnels',
      description: 'Partenaire de confiance pour les grossistes et professionnels du secteur floral, volumes importants et service personnalisé.'
    },
    {
      icon: 'ri-box-3-line',
      title: 'Gestion de Stock',
      description: 'Stand dédié au Marché de Rungis pour la gestion et le stockage temporaire de vos fleurs dans des conditions optimales.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Livraisons Planifiées',
      description: 'Organisation de livraisons régulières selon vos besoins, avec planification flexible et suivi en temps réel.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantie Qualité',
      description: 'Manipulation soignée et transport adapté pour garantir la fraîcheur et la qualité de vos fleurs à l\'arrivée.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-black to-emerald-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nos Services
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Une gamme complète de solutions logistiques adaptées aux professionnels du secteur floral
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm p-4 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow border border-white/20"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-emerald-600 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${service.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-white mb-2 md:mb-4">
                {service.title}
              </h3>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
